import PixAlloy from "./PixAlloy";
export default function App() { return <PixAlloy />; }
